// src/components/EntriesList/styles/entryStyles.js
/**
 * Zentrale Styles für alle EntriesList-Komponenten
 */
export const styles = {
    // Hauptcontainer
    container: {
      padding: '1rem',
      fontFamily: 'Arial, sans-serif'
    },
    title: {
      textAlign: 'center',
      marginBottom: '1rem',
      fontSize: '1.8rem',
      color: '#374151',
    },
    topContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '1rem',
      flexWrap: 'wrap',
      gap: '1rem',
    },
    searchInput: {
      flex: '1',
      minWidth: '250px',
      padding: '0.5rem',
      fontSize: '1rem',
      border: '1px solid #d1d5db',
      borderRadius: '6px',
    },
    feiertagButton: {
      padding: '0.5rem 1rem',
      backgroundColor: '#2563eb',
      color: '#fff',
      border: 'none',
      borderRadius: '6px',
      cursor: 'pointer',
      fontSize: '1rem',
      transition: 'background-color 0.2s',
      ":hover": {
        backgroundColor: '#1d4ed8',
      }
    },
    
    // Tabellenstile
    tableContainer: {
      overflowX: 'auto',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      borderRadius: '8px',
      backgroundColor: '#fff',
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      minWidth: '1000px',
    },
    th: {
      backgroundColor: '#f3f4f6',
      padding: '0.75rem',
      textAlign: 'left',
      borderBottom: '2px solid #e5e7eb',
      fontSize: '0.875rem',
      fontWeight: '600',
      color: '#4b5563',
    },
    td: {
      padding: '0.75rem',
      borderBottom: '1px solid #e5e7eb',
      fontSize: '0.875rem',
      color: '#4b5563',
    },
    iconButton: {
      backgroundColor: 'transparent',
      border: 'none',
      fontSize: '1.2rem',
      cursor: 'pointer',
      marginRight: '0.5rem',
      transition: 'transform 0.2s',
      ":hover": {
        transform: 'scale(1.1)',
      }
    },
    
    // Export-Stile
    exportContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
      flex: '1',
      minWidth: '250px',
      justifyContent: 'flex-end',
    },
    exportLabel: {
      fontSize: '1rem',
      color: '#374151',
    },
    exportSelect: {
      padding: '0.5rem',
      fontSize: '1rem',
      border: '1px solid #d1d5db',
      borderRadius: '6px',
    },
    exportBtn: {
      padding: '0.5rem 1rem',
      backgroundColor: '#10b981',
      color: '#fff',
      border: 'none',
      borderRadius: '6px',
      cursor: 'pointer',
      fontSize: '1rem',
      transition: 'background-color 0.2s',
      ":hover": {
        backgroundColor: '#059669',
      }
    },
    
    // Popup-Stile für Feiertage-Dialog
    popupOverlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
    },
    popupContent: {
      backgroundColor: '#fff',
      padding: '2rem',
      borderRadius: '8px',
      width: '400px',
      boxShadow: '0 4px 14px rgba(0,0,0,0.1)',
    },
    popupSelect: {
      width: '100%',
      padding: '10px',
      marginBottom: '20px',
      fontSize: '1rem',
      border: '1px solid #d1d5db',
      borderRadius: '6px',
    },
    popupButtons: {
      display: 'flex',
      justifyContent: 'flex-end',
      gap: '1rem',
    },
    popupOkButton: {
      padding: '10px 20px',
      backgroundColor: '#4CAF50',
      color: 'white',
      border: 'none',
      borderRadius: '5px',
      cursor: 'pointer',
    },
    popupCancelButton: {
      padding: '10px 20px',
      backgroundColor: '#f44336',
      color: 'white',
      border: 'none',
      borderRadius: '5px',
      cursor: 'pointer',
    },
    
    // Modal-Stile für EditEntryModal
    modal: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
    },
    modalContainer: {
      backgroundColor: '#fff',
      padding: '20px',
      borderRadius: '8px',
      width: '900px',
      maxWidth: '95%',
      maxHeight: '95vh',
      boxShadow: '0 4px 14px rgba(0,0,0,0.2)',
      display: 'flex',
      flexDirection: 'column',
    },
    modalHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderBottom: '1px solid #e5e7eb',
      paddingBottom: '15px',
      marginBottom: '20px',
    },
    modalCloseBtn: {
      background: 'transparent',
      border: 'none',
      fontSize: '1.5rem',
      cursor: 'pointer',
      color: '#6b7280',
      transition: 'color 0.2s',
      ":hover": {
        color: '#374151',
      }
    },
    tabHeader: {
      display: 'flex',
      borderBottom: '1px solid #e5e7eb',
      marginBottom: '20px',
    },
    tabButton: {
      flex: 1,
      padding: '12px',
      background: 'none',
      border: 'none',
      borderBottom: '3px solid transparent',
      cursor: 'pointer',
      fontSize: '1rem',
      color: '#6b7280',
      transition: 'all 0.2s',
      ":hover": {
        color: '#374151',
        backgroundColor: '#f9fafb',
      }
    },
    tabButtonActive: {
      flex: 1,
      padding: '12px',
      background: 'none',
      border: 'none',
      borderBottom: '3px solid #2563eb',
      cursor: 'pointer',
      fontSize: '1rem',
      fontWeight: 'bold',
      color: '#2563eb',
    },
    contentWrapper: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      overflow: 'hidden',
    },
    modalContent: {
      flex: 1,
      overflowY: 'auto',
      padding: '0 15px',
      transition: 'all 0.3s ease',
    },
    modalFooter: {
      display: 'flex',
      justifyContent: 'flex-end',
      gap: '10px',
      marginTop: '20px',
      padding: '15px 0',
      borderTop: '1px solid #e5e7eb',
    },
    
    // Formular-Stile
    formGroup: {
      marginBottom: '15px',
      display: 'flex',
      flexDirection: 'column',
    },
    formGroupRow: {
      display: 'flex',
      gap: '20px',
      flexWrap: 'wrap',
      marginBottom: '15px',
    },
    input: {
      padding: '10px',
      fontSize: '1rem',
      border: '1px solid #d1d5db',
      borderRadius: '6px',
      transition: 'border-color 0.2s',
      ":focus": {
        borderColor: '#2563eb',
        outline: 'none',
      }
    },
    datePickerInput: {
      padding: '10px',
      fontSize: '1rem',
      border: '1px solid #d1d5db',
      borderRadius: '6px',
      cursor: 'pointer',
      width: '100%',
    },
    checkboxLabel: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      cursor: 'pointer',
      userSelect: 'none',
    },
    updateBtn: {
      backgroundColor: '#10b981',
      color: '#fff',
      border: 'none',
      borderRadius: '6px',
      padding: '10px 20px',
      cursor: 'pointer',
      fontSize: '1rem',
      transition: 'background-color 0.2s',
      ":hover": {
        backgroundColor: '#059669',
      }
    },
    cancelBtn: {
      backgroundColor: '#6b7280',
      color: '#fff',
      border: 'none',
      borderRadius: '6px',
      padding: '10px 20px',
      cursor: 'pointer',
      fontSize: '1rem',
      transition: 'background-color 0.2s',
      ":hover": {
        backgroundColor: '#4b5563',
      }
    },
    historyBtn: {
      backgroundColor: '#8b5cf6',
      color: '#fff',
      border: 'none',
      borderRadius: '6px',
      padding: '10px 20px',
      cursor: 'pointer',
      fontSize: '1rem',
      marginRight: 'auto',
      transition: 'background-color 0.2s',
      ":hover": {
        backgroundColor: '#7c3aed',
      }
    },
    
    // Historie-Stile
    historyModal: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
    },
    historyModalContent: {
      backgroundColor: '#fff',
      padding: '2rem',
      borderRadius: '8px',
      width: '95%',
      maxWidth: '1400px',
      maxHeight: '90vh',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
    },
    historyTableContainer: {
      flex: 1,
      overflow: 'auto',
      border: '1px solid #e5e7eb',
      borderRadius: '6px',
      marginTop: '1rem',
    },
    historyTable: {
      width: '100%',
      borderCollapse: 'collapse',
    },
    historyTh: {
      backgroundColor: '#f3f4f6',
      padding: '10px',
      textAlign: 'left',
      borderBottom: '2px solid #e5e7eb',
      fontSize: '0.75rem',
      fontWeight: '600',
      color: '#4b5563',
      position: 'sticky',
      top: 0,
      whiteSpace: 'nowrap',
    },
    historyTd: {
      padding: '8px',
      borderBottom: '1px solid #e5e7eb',
      fontSize: '0.75rem',
      whiteSpace: 'nowrap',
    },
    changedOld: {
      color: '#ef4444',
      fontWeight: 600,
      backgroundColor: '#fee2e2',
    },
    changedNew: {
      color: '#10b981',
      fontWeight: 600,
      backgroundColor: '#d1fae5',
    },
  };